import React from "react";
import {Container} from "@material-ui/core";
import InteractiveVideo from "./InteractiveVideo";


const App = () => {
    return (
        <InteractiveVideo/>
    );
}

export default App;
